export default __webpack_public_path__ + "static/media/Gilroy-UltraLightItalic.371171f4.woff";